/**
 * @internal The priority used by the core extension to indicate that a full sync was completed.
 */
export const FULL_SYNC_PRIORITY = 2147483647;
export const MAX_OP_ID = '9223372036854775807';
//# sourceMappingURL=constants.js.map